// ChatToolStep — one step of the assistant's live timeline
// (ChatMessage.Activity): the step's own row (ChatToolRow) and, under it, the
// question that step asked.
//
// THE QUESTION SITS UNDER THE STEP THAT ASKED (Nika 2026-10-28: "fix
// positioning"). A question card (ask_user / confirm_with_user, ChatCard
// PvCardChoice) carries the call id of its step (`_callId`: the transport's
// _askOnCard live, sessions.js _askCardFromHistory on a reload), and
// ChatMessage.Activity hands each step the cards that name it (`_asks`). The
// card was drawn in ChatMessage.Cards: after the answer bubble, 35–37px under
// its step while the turn waited, with the reply's text pushed between the
// two once it came, and the two cards of a turn that asked twice both under
// its last step (the first 182px from its own) — measured on dev 2026-10-28.
//
// On the answer's text edge: the timeline's inset (Activity `Y`) plus this
// slot's `Z` is the answer block's `A` — the edge the step's status glyph and
// the answer text share.
export const ChatToolStep = {
  extends: 'ChatToolRow',

  StepAsks: {
    hide: (el, s) => !(Array.isArray(s._asks) && s._asks.length),
    flow: 'y',
    gap: 'Z',
    width: '100%',
    minWidth: '0',
    padding: 'X 0 Y Z',
    childExtends: 'ChatCard',
    childrenAs: 'state',
    children: (el, s) => (Array.isArray(s._asks) ? s._asks : [])
  }
}
